import React from 'react'

function VersionNotes() {
  return (
    <ul>
            <li>
              ⚡New Black and Orange Theme launched for 1st work Anniversary 🎨.
            </li>
            <li>✅ Ui Fixes in Experiance tab</li>
            <li>💬 Optimised AI Powered Chat Bot to tell about me.</li>
            <li>
              📝{" "}
              <a href="https://kasyap.netlify.app/Dev_Notes.txt">
                Documentation
              </a>{" "}
              updated with new features.
            </li>
          </ul>
  )
}

export default VersionNotes